var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"modalName":"DEMLegendModal","title":"Legenda - DEM","buttons":['']}},[_c('v-img',{attrs:{"src":require('@/LegendDEM.png'),"height":"550px","width":"200px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3357a090","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/start/modals/DEMLegend.vue
// module id = 2045
// module chunks = 0